import { Create, useGetIdentity } from 'react-admin';
import { NewsForm } from './NewsForm';
import { transformMediaUrlInput } from '../../lib/media/makeUrl'
import { fromGenericToUTC } from '../../lib/i18n/utils';
import { usePermissionGuard } from '../../lib/permissions/usePermissionGuard';

export const NewsCreate = (props: any) => {
  const { guard } = usePermissionGuard();

  const transform = data => ({
    ...data,
    isLocalNews: guard.forceLocal() ? guard.forceLocal() : data.isLocalNews,
    publishedAt: data.publishedAt ? fromGenericToUTC(data.publishedAt) : null,
    agendaIds: data.agendaIds ?? [],
    topicIds: data.topicIds ?? [],
    sectorIds: data.sectorIds ?? [],
    mediaUrl: transformMediaUrlInput(data.mediaUrl)
  });
  const { identity, isLoading } = useGetIdentity();

  if (isLoading && !identity) return null;
  return (
    <Create {...props} transform={transform}>
      <NewsForm username={identity.fullName} />
    </Create>
  );
};
